import React from 'react'
// import { withRouter  } from "react-router-dom";
import Logo from './../logo/Logo'
import { useSelector } from 'react-redux'
import './styles.scss'
import xkom from './../../images/shop-logo.jpg';
// import phone from './../../images/phone-grey-ico.svg';
import getDataFromUrl from './../../services/getDataFromUrl';
import { useNavigate } from "react-router";

const Header = (props) => {
    let isShop          = useSelector(state => state.isShop)
    let step            = useSelector(state => state.step)
    let callNumber      = useSelector(state => state.callNumber);
    let navigate = useNavigate();

    let partnerLogo = window.AppConfig ? window.AppConfig.partnerLogo : '';
    let k = getDataFromUrl("k");

    let returnCalc = () => {
        navigate(isShop ? '/sklep':'/')
    }

    return (
        <nav>
            <div className="container">
                <div className="logos-col">
                    <Logo setFunction={ () => returnCalc() } />
                    {/* <div className="shop-logo">
                        <img src={partnerLogo} alt="" />
                    </div> */}
                </div>
                <div className="info-col">
                    {/* <div className={"info" + ( step > 1 ? '' : ' margin-reset')}>
                        <img src={ phone } alt="Zadzwoń" />
                        {!callNumber && k !== "dok" &&
                            <a href="tel: 61 872 37 00">61 / 872 37 00</a>
                        }
                        {!callNumber && k == "dok" &&
                            <a href="tel: 61 872 37 51">61 / 872 37 51</a>
                        }
                        {callNumber &&
                            <a href={"tel:" + callNumber.replace('/', '')}>{ callNumber }</a>
                        }
                    </div> */}
                    {/* { step > 1 && 
                        <div className="prev-calc" role="link" onClick={ () => returnCalc() } >Powrót do kalkulatora</div>
                    } */}
                </div>
            </div>
        </nav>
    )
}

// export default withRouter(Header);
export default Header;